module.exports = __webpack_public_path__ + "img/world_of_acredo.ce779f5.webp";